import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_35_15013)"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_35_15013"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "18",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_center_wrapper = _resolveComponent("center-wrapper");
  return _openBlock(), _createBlock(_component_center_wrapper, null, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", {
      width: $props.width,
      height: $props.height,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 9L13.9425 7.9425L9.75 12.1275L9.75 3L8.25 3L8.25 12.1275L4.065 7.935L3 9L9 15L15 9Z",
      fill: $props.color
    }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1))]),
    _: 1
  });
}